import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './users.service';


@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private userService: UserService) { }

 intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    request = request.clone({
      setHeaders: {
        Authorization: this.userService.getToken()
      }
    });

    return next.handle(request);
  }

   

}
